import React from "react";

const CustomTimePicker = ({ label, value = "12:00 PM", onChange }) => {
  // Split into hour, minute, period
  const [hour, minute, period] = value
    ? value.split(/[: ]/)
    : ["12", "00", "AM"];

  // Generate 1–12 hours
  const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));
  // Generate 00–59 minutes
  const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

  const handleChange = (type, val) => {
    const newHour = type === "hour" ? val : hour;
    const newMinute = type === "minute" ? val : minute;
    const newPeriod = type === "period" ? val : period;

    const formattedTime = `${newHour}:${newMinute} ${newPeriod}`;
    onChange(formattedTime);
  };

  return (
    <div className="flex flex-col space-y-1 w-full">
      {label && (
        <label className="font-medium text-gray-700 text-sm">{label}</label>
      )}

      <div className="flex items-center space-x-2">
        {/* Hour Picker */}
        <select
          value={hour}
          onChange={(e) => handleChange("hour", e.target.value)}
          className="border rounded-md px-2 py-2 focus:ring-1 focus:ring-red-500"
        >
          {hours.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>

        <span>:</span>

        {/* Minute Picker */}
        <select
          value={minute}
          onChange={(e) => handleChange("minute", e.target.value)}
          className="border rounded-md px-2 py-2 focus:ring-1 focus:ring-red-500"
        >
          {minutes.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>

        {/* AM / PM Picker */}
        <select
          value={period}
          onChange={(e) => handleChange("period", e.target.value)}
          className="border rounded-md px-2 py-2 focus:ring-1 focus:ring-red-500"
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
};

export default CustomTimePicker;
